import { render, staticRenderFns } from "./approvaldetails.vue?vue&type=template&id=74817107&"
import script from "./approvaldetails.vue?vue&type=script&lang=js&"
export * from "./approvaldetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports